const NO_FIXED_ABODE_POSTCODE = 'ZZ993VZ';

export default async function validatePostcode(postcode) {
  const strippedPostcode = postcode.toUpperCase().replaceAll(' ', '');

  if (strippedPostcode === NO_FIXED_ABODE_POSTCODE) {
    return true;
  }

  const response = await fetch(
    `https://api.postcodes.io/postcodes/${strippedPostcode}/validate`
  );
  // Don't let API errors fail validation
  if (!response.ok) {
    return true;
  }

  const { result } = await response.json();
  return result;
}

export const INVALID_POSTCODE = 'Please check the postcode is correct';
